import { element } from 'protractor';
import {
  Component,
  OnInit,
  OnChanges,
  OnDestroy,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  SimpleChanges,
} from "@angular/core";
import { Vacation } from "../../../class/vacation";
import { VacationService } from "../../../service/vacation/vacation.service";
import { TranslateService } from "@ngx-translate/core";
import { HasPermissionService } from "../../../service/has-permission/has-permission.service";
import {
  AbstractControl,
  FormGroup,
  FormBuilder,
  Validators,
  ValidationErrors,
  FormControl,
  FormArray,
} from "@angular/forms";
import {
  Message,
  ConfirmationService,
  LazyLoadEvent,
  CalendarModule,
  ToggleButtonModule,
} from "primeng/primeng";
import { NotificationsService } from "../../../../../theme/services/notifications/notifications.service";
import { calendarES } from "../../../../../theme/functions/calendarES";
import { formatDate } from "../../../../../theme/functions/formatDate.function";
import { config } from "../../../../../../environments/config";
import { Router, ActivatedRoute } from "@angular/router";
import { DISABLED } from "@angular/forms/src/model";

@Component({
  selector: "app-new-vacation",
  templateUrl: "./new-vacation.component.html",
  styleUrls: ["./new-vacation.component.scss"],
})
export class NewVacationComponent implements OnInit {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() subPagePath: string;

  public modNew = false;
  public modView = false;
  public promiseForm: Promise<any>;
  public msgs: Message[] = [];
  public totalRecords: number;
  public page: number;
  public per_page: number;
  public requestData: any[];
  public requestVacation: any;
  public sort: string;
  public query: string;
  public loading: boolean = true;
  public es: any;
  public showFilter: boolean;
  public apiUrl = config.API_ROOT;
  public modVacationsDialog: boolean = false;
  public modExportDialog: boolean = false;
  public filters: { key: string; value: string }[];
  public first = 0;
  public form_edit_vacations: FormGroup;
  public form_new_vacations: FormGroup;
  public editForm: any[] = [];
  public current_date: Date;
  public edit: Vacation;
  public myEmployeeId: string;
  public myEmployeeName: string;
  public created_by_id: any = null;
  private id: any;
  public contractId: number;
  public start_contract: any;
  public company_id: any;
  public candidate_id: any;
  public department_id: any;
  public venue_id: any;
  public contract_id: any;
  public work_days: any;
  public vacations_days: any;
  public taken_days: any;
  public pending_days: any;
  public doRequest: number = 0;

  constructor(
    public fb: FormBuilder,
    private route: ActivatedRoute,
    public activatedRoute: ActivatedRoute,
    private router: Router,
    public vacationService: VacationService,
    public hasPermissionService: HasPermissionService,
    private notificationsService: NotificationsService,
    public translate: TranslateService
  ) {
    this.es = calendarES();
  }

  ngOnInit() {
    this.contractId = +this.route.snapshot.paramMap.get("id");
    this.myEmployeeId = JSON.parse(localStorage.getItem("profile")).employee.id;
    this.current_date = new Date();

    if (this.contractId !== 0 && this.contractId !== undefined) {
      this.loading = true;
      this.createEditVacationsForm();
      this.vacationService
        .getVacation(this.contractId)
        .toPromise()
        .then(
          (response) => {
            this.loading = false;
            this.edit = response.json();
            this.createEditVacationsForm(this.edit);
            this.listFieldsFormsArray(
              this.new_vacations,
              this.edit.new_vacations,
              "new_vacations"
            );
            this.id = this.edit.id;
            this.contract_id = this.contractId;
            this.candidate_id = this.edit.candidate_id;
            this.start_contract = this.edit.start_contract;
            this.company_id = this.edit.company_id;
            this.venue_id = this.edit.venue_id;
            this.department_id = this.edit.department_id;
            this.work_days = this.edit.work_days;
            this.vacations_days = this.edit.vacations_days;
            this.taken_days = this.edit.taken_days;
            this.pending_days = this.edit.pending_days;

            this.doRequest = 1;
          },
          (error) => {
            this.loading = false;
            this.msgs = [];
            this.msgs.push({ severity: "error", summary: "error" });
            this.notificationsService.growlNotify(
              "error",
              "ID " + this.contract_id + " no encontrado"
            );
            this.router.navigateByUrl("/pages/vacations");
          }
        );
    } else {
      this.createEditVacationsForm();
      this.doRequest = 1;
    }
  }

  createEditVacationsForm(data: any = null) {
    data = data || {
      id: this.id,
      candidate_id: this.candidate_id,
      company_id: this.company_id,
      venue_id: this.venue_id,
      department_id: this.department_id,
      start_contract: this.start_contract,
      contract_id: this.contract_id,
      current_date: this.current_date,
      work_days: this.work_days,
      vacations_days: this.vacations_days,
      taken_days: this.taken_days == null ? 0 : this.taken_days,
      pending_days: this.pending_days == null ? 0 : this.pending_days,
    };

    this.form_edit_vacations = this.fb.group({
      id: [data.id, []],
      contract_id: [data.contract_id, []],
      candidate_id: [data.candidate_id, []],
      company_id: [data.company_id, []],
      venue_id: [data.venue_id, []],
      department_id: [data.department_id, []],
      start_contract: [
        {
          value: data.start_contract ? new Date(data.start_contract) : null,
          disabled: false,
        },
      ],
      current_date: [
        {
          value: data.current_date ? new Date(data.current_date) : null,
          disabled: false,
        },
      ],
      work_days: [data.work_days, []],
      vacations_days: [data.vacations_days, []],
      taken_days: [data.taken_days, []],
      pending_days: [data.pending_days, []],

      new_vacations: this.fb.array([]),
    });
  }

  CreateNewVacationsForm(data: any = null) {
    this.myEmployeeName = JSON.parse(
      localStorage.getItem("profile")
    ).employee.name;
    data = data || {
      id: undefined,
      // created_by_id: this.myEmployeeId,
      created_by_id: this.myEmployeeId,
      created_date: this.current_date,
      start_vacations_date: null,
      end_vacations_date: null,
      enjoy_days: "",
      pay_days: "",
      total_days: "",
    };

    const form_new_vacations = this.fb.group({
      id: [data.id],
      created_by_id: [data.created_by_id, []],
      created_date: [
        {
          value: data.created_date ? new Date(data.created_date) : null,
          disabled: false,
        },
      ],
      start_vacations_date: [
        {
          value: data.start_vacations_date
            ? new Date(data.start_vacations_date)
            : null,
          disabled: false,
        },
        [Validators.required],
      ],
      end_vacations_date: [
        {
          value: data.end_vacations_date
            ? new Date(data.end_vacations_date)
            : null,
          disabled: false,
        },
        [Validators.required],
      ],
      enjoy_days: [
        data.enjoy_days,
        [Validators.required, Validators.pattern("^[0-9]+$")],
      ],
      pay_days: [
        data.pay_days,
        [Validators.required, Validators.pattern("^[0-9]+$")],
      ],
    });

    this.editForm.push(data);
    this.new_vacations.push(form_new_vacations);
    return;
  }

  get new_vacations() {
    return this.form_edit_vacations.controls["new_vacations"] as FormArray;
  }

  public newVacations(values) {
    //this.form_edit_vacations;
    values.id = values.id;
    values.contract_id = values.contract_id;
    values.candidate_id = values.candidate_id;
    values.company_id = values.company_id.id;
    values.venue_id = values.venue_id;
    values.department_id = values.department_id;
    values.start_contract = formatDate(this.start_contract);
    values.current_date = formatDate(this.current_date);
    values.work_days = values.work_days;
    values.vacations_days = values.vacations_days;
    values.taken_days = values.taken_days == null ? 0 : values.taken_days;
    values.pending_days = values.pending_days == null ? 0 : values.pending_days;

    var param = {
      id: values.id,
      candidate_id: values.candidate_id,
      contract_id: values.contract_id,
      company_id: values.company_id,
      venue_id: values.venue_id,
      department_id: values.department_id,
      start_contract: values.start_contract,
      current_date: values.current_date,
      work_days: values.work_days,
      vacations_days: values.vacations_days,
      taken_days: values.taken_days,
      pending_days: values.pending_days,
    };

    if (values.new_vacations) {
      for (let i = 0; i < values.new_vacations.length; i++) {
        values.new_vacations[i].id =
          values.new_vacations[i].id == null
            ? undefined
            : values.new_vacations[i].id;


        values.new_vacations[i].created_by_id =
          values.new_vacations[i].created_by_id.id;
        //values.new_vacations[i].created_date = formatDate(new Date());
        values.new_vacations[i].start_vacations_date = formatDate(
          values.new_vacations[i].start_vacations_date
        );
        values.new_vacations[i].end_vacations_date = formatDate(
          values.new_vacations[i].end_vacations_date
        );
        values.new_vacations[i].enjoy_days =
          parseInt(values.new_vacations[i].enjoy_days, 10) || 0;
        values.new_vacations[i].pay_days =
          parseInt(values.new_vacations[i].pay_days, 10) || 0;
        values.new_vacations[i].created_date =
          values.new_vacations[i].created_date == null
            ? formatDate(new Date())
            : formatDate(values.new_vacations[i].created_date);

        if (this.edit.new_vacations && this.edit) {
          if (
            this.edit.new_vacations.length > 0 &&
            this.edit.new_vacations[i]
          ) {
            if (
              this.edit.new_vacations[i].created_date != null &&
              this.edit.new_vacations[i].created_date != undefined
            ) {
              values.new_vacations[i].created_date =
                this.edit.new_vacations[i].created_date;
            } else {
              values.new_vacations[i].created_date = formatDate(new Date());
            }
          } else {
            values.new_vacations[i].created_date = formatDate(new Date());
          }
        } else {
          values.new_vacations[i].created_date = formatDate(new Date());
        }
      }

      param["new_vacations"] = values.new_vacations;
    }

    if (values) {
      if (values.id !== null) {
        const promise = this.vacationService.updateVacation(
          values,
          values.contract_id
        );
        this.promiseForm = promise.toPromise().then(
          (response) => {
            this.translate.get("saved").subscribe((res: string) => {
              this.notificationsService.growlNotify("success", res);
              this.msg.emit({ severity: "success", summary: res });
              this.close.emit(true);
              this.form_edit_vacations.reset();
            });
            this.router.navigateByUrl("/pages/vacations");
          },
          (error) => {
            let msg = "";

            JSON.parse(error._body).errors.forEach((element) => {
              var err = element;
              if (element.detail)
                //
                err = element.detail;

              this.translate.get(err).subscribe((res3: string) => {
                msg = msg + res3 + ", ";
              });
            });
            this.notificationsService.growlNotify("error", "" + msg);
          }
        );
      } else {
        const promise = this.vacationService.addVacation(values);
        this.promiseForm = promise.toPromise().then(
          (response) => {
            this.translate.get("saved").subscribe((res: string) => {
              this.notificationsService.growlNotify("success", res);
              this.close.emit(true);
              this.form_edit_vacations.reset();
            });
            this.router.navigateByUrl("/pages/vacations");
          },
          (error) => {
            let msg = "";

            JSON.parse(error._body).errors.forEach((element) => {
              var err = element;
              if (element.detail)
                //
                err = element.detail;

              this.translate.get(err).subscribe((res3: string) => {
                msg = msg + res3 + ", ";
              });
            });
            this.notificationsService.growlNotify("error", "" + msg);
          }
        );
      }
    }
  }

  listFieldsFormsArray(formArrayLoc: FormArray, data: any[], field: string) {
    this.clearFormArray(formArrayLoc);
    if (data && Array.isArray(data) && data.length > 0) {
      data.forEach((element) => {

        this.created_by_id = element.created_by_id;
        this.CreateNewVacationsForm(element);

      });
    } else {
      console.warn("No data found or data is not an array");
    }
  }

  clearFormArray = (formArray: FormArray) => {
    while (formArray.length !== 0) {
      formArray.removeAt(0);
    }
  };

  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public hasRole(rol) {
    var r: boolean = false;
    var role = JSON.parse(localStorage.getItem("profile")).roles[0].id;
    if (role == rol) r = true;

    return r;
  }

  public cancelEditVacations(values) {
    this.form_edit_vacations.reset();
    this.close.emit(true);
    this.router.navigateByUrl("/pages/vacations");
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/employee/pages/vacations/new-vacation/new-vacation.component.ts